<script setup lang="ts">
// No props needed since we're removing the assets section
</script>

<template>
  <UiCard class="border-none p-0 shadow-none">
    <UiCardHeader class="pb-2">
      <div class="flex items-center gap-3">
        <!-- Avatar skeleton -->
        <UiAvatar>
          <UiAvatarFallback>
            <NSkeleton class="size-5" wave />
          </UiAvatarFallback>
        </UiAvatar>

        <div class="flex-1">
          <div class="flex items-center justify-between">
            <!-- Author name skeleton -->
            <NSkeleton class="h-5 w-24" wave />
            <!-- Date skeleton -->
            <NSkeleton class="h-4 w-16" wave />
          </div>

          <div class="mt-1 flex items-center">
            <!-- Rating skeleton -->
            <NSkeleton class="h-4 w-24" wave />
          </div>
        </div>
      </div>
    </UiCardHeader>

    <UiCardContent>
      <div class="space-y-3">
        <!-- Review summary skeleton -->
        <NSkeleton class="h-5 w-2/3" wave />

        <!-- Review body skeleton -->
        <div class="space-y-2">
          <NSkeleton class="h-4 w-full" wave />
          <NSkeleton class="h-4 w-5/6" wave />
          <NSkeleton class="h-4 w-4/6" wave />
        </div>
      </div>
    </UiCardContent>

    <UiCardFooter class="flex items-center justify-between pt-0">
      <!-- Helpful button skeleton -->
      <NSkeleton class="h-8 w-24" wave />
    </UiCardFooter>
  </UiCard>
</template>
